import { useQuery } from "@tanstack/react-query";

import { api } from "@/config/api";
import { queryKeys } from "@/hooks/queries";
import type { ApiResponse, ProgressReview, UserProgress } from "@/types";

interface ProgressApiResponse extends ApiResponse {
  progress: UserProgress[];
  nextCursor: string | null;
}

interface ProgressReviewApiResponse extends ApiResponse {
  review: ProgressReview;
}

export function useProgress(limit = 20, cursor?: string) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set("cursor", cursor);

  return useQuery({
    queryKey: [...queryKeys.progress, limit, cursor],
    queryFn: () => api.get<ProgressApiResponse>(`/api/progress?${params}`),
    select: (data) => ({
      items: data.progress,
      nextCursor: data.nextCursor,
    }),
  });
}

export function useProgressReview(scenarioId: string) {
  return useQuery({
    queryKey: [...queryKeys.progress, "review", scenarioId],
    queryFn: () => api.get<ProgressReviewApiResponse>(`/api/progress/${scenarioId}`),
    select: (data) => data.review,
    enabled: !!scenarioId,
  });
}
